import React, { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks/redux';
import jsCookie from "js-cookie";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";
import { getOnePagerExecutiveSummary } from './action';
import DotLoader from 'src/components/reusable/dot-loader';

const ExecutiveSummary = () => {
    const dispatch = useAppDispatch();
    const userId = jsCookie.get("user_id");
    const [searchParams] = useSearchParams();
    const threadId = `${searchParams.get("threadId")}`
    const [loading, setLoading] = React.useState(true);
    const [executiveSummary, setExecutiveSummary] = React.useState<any>(null);

    const postInteractiveInput = async () => {
        setLoading(true);
        try {
            const insightsResp = await dispatch(
                getOnePagerExecutiveSummary({ userId: userId || "", threadId })
            ).unwrap();


            setExecutiveSummary(insightsResp.data);

           
            setLoading(false);
        } catch (error) {
            console.error("Error fetching executive summary:", error);
        }
    };

    useEffect(() => {
        if (userId && threadId) {
            postInteractiveInput();
        }
    }, [userId, threadId]);

    return (
        <div>
            {
                loading && !executiveSummary ? (
                    <div className="flex items-center justify-center p-5 h-full w-full section-block pt-2 min-h-[50vh]">
                        <DotLoader />
                    </div>
                ) : executiveSummary?.sections?.map((summary: any) => (
                    <div className="p-4 bg-white rounded-xl shadow-sm space-y-4" key={summary.section_title}>
                        {/* Section Title */}
                        <h2 className="text-xl font-bold text-gray-900 border-b pb-2">
                            {summary.section_title}
                        </h2>

                        {/* Bullets */}
                        <ul className="list-disc space-y-2 text-gray-800 pl-[15px]">
                            {summary.bullets.map((point: string, idx: number) => (
                                <li key={idx}>
                                    {point}
                                    {/* <Markdown
                                        remarkPlugins={[remarkGfm]}
                                        rehypePlugins={[
                                            [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                                        ]}
                                    >
                                        {point}
                                    </Markdown> */}
                                </li>
                            ))}
                        </ul>

                        {/* Executive Signal */}
                        <div className="p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded-md">
                            <strong className="block mb-1 text-gray-900">Executive Signal:</strong>
                            <p className="text-gray-800">{summary.executive_signal}</p>
                        </div>

                        {/* Citations */}
                        {summary.citations?.length > 0 && (
                            <div>
                                <h3 className="font-semibold text-gray-900 mb-2">Citations</h3>
                                <ul className="space-y-1 text-blue-600">
                                    {summary.citations.map((cite: any, idx: number) => (
                                        <li key={idx}>
                                            <a
                                                href={cite.split(" - ")?.[1]?.trim() || cite}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="hover:underline break-words"
                                            >
                                                {cite.split("-")?.[0] || cite}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                ))
            }
        </div >
    )
}

export default ExecutiveSummary
